/* ROI Study calculator — two modes, one package list.
   Racer:  value   = alignments × cost
           payback = price ÷ value × 12 months
   Shop:   margin  = charge − hours per setup × labor rate     (per setup)
           n       = ceil(price ÷ margin)                      setups to pay it off
           weeks   = n ÷ setups per week                       calendar payback
           hours   = n × hours per setup                       setup work to pay it off
           perHour = charge ÷ hours per setup                  what setup work earns
           margin/yr = setups per week × weeks × margin */
(function () {
  'use strict';

  var money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
  var moneyExact = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 2 });

  function num(el) {
    var v = el ? parseFloat(el.value) : NaN;
    return isFinite(v) && v >= 0 ? v : 0;
  }
  function plural(n, word) { return n + ' ' + word + (n === 1 ? '' : 's'); }
  function fmtMonths(m) { return m >= 24 ? (m / 12).toFixed(1) + ' years' : plural(Math.round(m), 'month'); }
  function fmtWeeks(w) {
    if (w <= 26) return plural(Math.ceil(w), 'week');
    var months = w / 4.33;
    return months >= 24 ? (months / 12).toFixed(1) + ' years' : plural(Math.round(months), 'month');
  }
  function trim(n) { return String(Math.round(n * 10) / 10); }

  function init(root) {
    if (!root || root.dataset.roiReady) return;
    root.dataset.roiReady = '1';

    var q = function (sel) { return root.querySelector(sel); };
    var f = {
      alignments: q('[name="alignments"]'), cost: q('[name="cost"]'),
      setupsWeek: q('[name="setups_week"]'), charge: q('[name="charge"]'), hps: q('[name="hours_per_setup"]'),
      labor: q('[name="labor_rate"]'), weeks: q('[name="weeks"]'),
      pkg: q('[name="package"]')
    };
    var out = {};
    root.querySelectorAll('[data-out]').forEach(function (el) { out[el.dataset.out] = el; });
    var set = function (key, text) { if (out[key]) out[key].textContent = text; };
    var modes = root.querySelectorAll('.roi-calc__modes input[type="radio"]');

    var userPickedPackage = false;
    if (f.pkg) f.pkg.addEventListener('change', function () { userPickedPackage = true; });

    function currentMode() {
      var checked = root.querySelector('.roi-calc__modes input[type="radio"]:checked');
      return checked ? checked.value : (root.dataset.roiMode || 'racer');
    }
    function applyMode(m) {
      root.dataset.roiMode = m;
      var wrap = root.closest('.roi-section');
      if (wrap) wrap.dataset.roiMode = m;
      if (userPickedPackage || !f.pkg) return;
      var slot = root.dataset[m === 'shop' ? 'shopPackage' : 'racerPackage'];
      for (var i = 0; i < f.pkg.options.length; i++) {
        if (f.pkg.options[i].dataset.slot === String(slot)) { f.pkg.selectedIndex = i; break; }
      }
    }
    function pkg() {
      var o = f.pkg && f.pkg.selectedIndex >= 0 ? f.pkg.options[f.pkg.selectedIndex] : null;
      return o ? { price: parseFloat(o.value) / 100, title: o.dataset.title || o.textContent } : { price: 0, title: '' };
    }

    function calcRacer() {
      var annual = num(f.alignments) * num(f.cost);
      var p = pkg();
      set('annual', money.format(annual));
      if (!(annual > 0) || !(p.price > 0)) {
        set('payback', ''); set('payback-sub', p.price > 0 ? 'Enter your numbers to see the payback.' : 'Pick a package.');
        set('net3', ''); set('net3-sub', '');
        return;
      }
      set('payback', fmtMonths(p.price / annual * 12));
      set('payback-sub', 'to pay back the ' + p.title + ' (' + moneyExact.format(p.price) + ')');
      var net = annual * 3 - p.price;
      set('net3', (net < 0 ? '−' : '') + money.format(Math.abs(net)));
      set('net3-sub', net < 0 ? 'still to recover after three seasons' : 'ahead after three seasons');
    }

    function calcShop() {
      var w = num(f.setupsWeek), ch = num(f.charge), hps = num(f.hps), rate = num(f.labor), wk = num(f.weeks);
      var p = pkg();
      var laborCost = hps * rate, margin = ch - laborCost, setupsYear = w * wk;

      set('shop-margin', money.format(Math.max(margin, 0) * setupsYear));
      set('shop-margin-sub', plural(Math.round(setupsYear), 'setup') + ' a year: ' + money.format(setupsYear * ch) + ' billed, less ' + money.format(setupsYear * laborCost) + ' of labor');

      if (!(p.price > 0)) {
        set('shop-payback', ''); set('shop-payback-sub', 'Pick a package.');
        set('shop-hours', ''); set('shop-hours-sub', '');
        return;
      }
      if (!(margin > 0)) {
        set('shop-payback', ''); set('shop-payback-sub', ch > 0 ? 'Labor costs more than the setup bills for, so it never pays back on margin.' : 'Enter what you charge per setup.');
        set('shop-hours', ''); set('shop-hours-sub', '');
        return;
      }
      var n = Math.ceil(p.price / margin);
      set('shop-hours', hps > 0 ? trim(n * hps) + ' hours' : plural(n, 'setup'));
      set('shop-hours-sub', plural(n, 'setup') + ' at ' + money.format(margin) + ' margin each' + (hps > 0 ? ', setup work bills ' + money.format(ch / hps) + ' an hour against a ' + money.format(rate) + ' labor rate' : ''));
      if (w > 0) {
        set('shop-payback', fmtWeeks(n / w));
        set('shop-payback-sub', 'at ' + trim(w) + ' setup' + (w === 1 ? '' : 's') + ' a week, against the ' + p.title + ' (' + moneyExact.format(p.price) + ')');
      } else {
        set('shop-payback', plural(n, 'setup'));
        set('shop-payback-sub', 'against the ' + p.title + ' (' + moneyExact.format(p.price) + '), add setups per week for a timeline');
      }
    }

    function calc() { if (currentMode() === 'shop') calcShop(); else calcRacer(); }

    modes.forEach(function (r) { r.addEventListener('change', function () { applyMode(r.value); calc(); }); });
    root.addEventListener('input', calc);
    root.addEventListener('change', calc);
    applyMode(currentMode());
    calc();
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-roi-calc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();